import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=b4688080&scoped=true"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQuestions.vue?vue&type=style&index=0&id=b4688080&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4688080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4688080')) {
      api.createRecord('b4688080', component.options)
    } else {
      api.reload('b4688080', component.options)
    }
    module.hot.accept("./AdditionalQuestions.vue?vue&type=template&id=b4688080&scoped=true", function () {
      api.rerender('b4688080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/AdditionalQuestions.vue"
export default component.exports